import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';
import { moduleConfig } from './sparePurchaseOrdersModuleConfig';
import {
  buildListQuery,
  ListQueryOptions,
  normalizePaginatedListResponse,
  PaginatedApiResponse,
} from '../../../services/paginatedList';

export interface SparePurchaseOrderLine {
  id?: number;
  itemId?: number | null;
  itemVcode?: string | null;
  itemDescr?: string | null;
  unitId?: number | null;
  qty?: number | null;
  unitPrice?: string | number | null;
  lineTotal?: string | number | null;
  discount?: string | number | null;
  vat?: string | number | null;
  requisitionQty?: number | null;
  enquiryQty?: number | null;
  quotationQty?: number | null;
  itemNotes?: string | null;
  item?: {
    level1?: string | null;
    level2?: string | null;
    level3?: string | null;
  } | null;
  unit?: { id?: number; ucode?: string | null; descr?: string | null } | null;
}

export interface SparePurchaseOrderExpense {
  id?: number;
  description?: string | null;
  value?: string | number | null;
  vat?: string | number | null;
}

export interface SparePurchaseOrder {
  id: number;
  orderDate?: string | null;
  caseId: number;
  supplierId: number;
  quotationId: number;
  ref?: string | null;
  currencyId?: number | null;
  exchangeRate?: string | number | null;
  exchangeDate?: string | null;
  paymentTerms?: string | null;
  notes?: string | null;
  createdAt: string;
  updatedAt: string;
  lineItems?: SparePurchaseOrderLine[];
  expenses?: SparePurchaseOrderExpense[];
  _count?: { lineItems: number };
  spareCase?: {
    id: number;
    ref?: string | null;
    vessel?: { id: number; vesselName?: string | null; vesselAbrv?: string | null } | null;
  } | null;
  quotation?: { id: number; ref?: string | null; quoDate?: string | null; enqId?: number | null } | null;
  supplier?: { id: number; name: string; code?: string | null; email?: string | null; isActive?: boolean } | null;
  currency?: { id: number; code: string; name: string; symbol?: string | null; isActive?: boolean } | null;
}

export const useSparePurchaseOrders = (
  searchParams?: string,
  page = 1,
  limit = 25,
  options?: ListQueryOptions,
) => {
  const q = buildListQuery(searchParams, page, limit, options);
  const { data, error, isLoading, mutate } = useSWR<
    PaginatedApiResponse<SparePurchaseOrder> | SparePurchaseOrder[]
  >(`${moduleConfig.module.api.list}${q}`, fetcher, { revalidateOnFocus: true });
  const normalized = normalizePaginatedListResponse<SparePurchaseOrder>(data, page, limit);
  return {
    data: normalized.data,
    clients: normalized.data,
    total: normalized.total,
    page: normalized.page,
    limit: normalized.limit,
    isLoading,
    isError: error,
    mutate,
  };
};

export const useSparePurchaseOrder = (id?: number) => {
  const { data, error, isLoading, mutate } = useSWR<SparePurchaseOrder>(
    id ? moduleConfig.module.api.detail(id) : null,
    fetcher,
    { revalidateOnFocus: true },
  );
  return { data, item: data, isLoading, isError: error, mutate };
};
